export const PATH = {
  LOGIN: '/login',
  FORGOT: '/forgot',
  REGISTER: '/register',
  REGISTER_COMPLETE: '/register-complete',
  RESET_PASSWORD: '/resetpassword',
  USERS: '/users',
  VERIFY_EMAIL: '/verify-email',
  EMPTY: '',
};

export default PATH;
